<template>
    <el-select v-model="selfValue" clearable placeholder="Property" @change="dataChange">
        <el-option
                v-for="item in propertyList"
                :key="item.propertyId+'prop'"
                :label="item.propertyName"
                :value="item.propertyId">
        </el-option>
    </el-select>
</template>

<script>
    import {allProperty} from "@/api/AuthApi";

    export default {
        name: "PropertySelector",
        props: {
            value: {required: false, type: Number},
        },
        data() {
            return {
                selfValue: this.selfValue ? this.selfValue : this.value,
                propertyList: []
            }
        },
        methods: {
            dataChange(val) {
                this.$emit('update:value', val)
            }
        }, created() {
            allProperty()
                .then(res => this.propertyList = res.data)
        }
    }
</script>

<style scoped>

</style>